import { render, staticRenderFns } from "./AlertEmail.vue?vue&type=template&id=4761b27b&scoped=true&"
import script from "./AlertEmail.vue?vue&type=script&lang=js&"
export * from "./AlertEmail.vue?vue&type=script&lang=js&"
import style0 from "./AlertEmail.vue?vue&type=style&index=0&id=4761b27b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4761b27b",
  null
  
)

export default component.exports